/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import AccountService from 'cio/services/account';
import { inject as service } from '@ember/service';

interface BetaLabelArgs {
  tooltipContent: string;
  tooltipClassNames: string;
  labelClassNames: string;
  acceptFeedback: boolean;
  tooltipDirection: string;
}

export default class BetaLabel extends Component<BetaLabelArgs> {
  @service account!: AccountService;

  @tracked modalOpened = false;
}
